import apiClient from 'utilities/apiClient';

export const signin = (payload) => {
  return apiClient.post(`${apiClient.Urls.signin}`, payload);
};

export const verify = (payload) => {
  return apiClient.post(`${apiClient.Urls.verify}`, payload);
};
